/**
 * The uuid predicates, in the one place both sides of the wire can read them.
 *
 * Every id column in the schema is a uuid, so "can this string name a row" is a
 * question the server asks when validating an argument and the client asks
 * before spending a request on one. Two copies of the pattern drift silently —
 * the failure is a value one side accepts and the other rejects, which surfaces
 * as a request that cannot succeed rather than as anything that fails a test.
 */
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Validates that a string is a well-formed UUID (any version, case-insensitive). */
export function isValidUuid(value: string): boolean {
  return UUID_REGEX.test(value);
}

/**
 * Strict v4 UUID predicate. Use this when validating capability tokens or
 * other security-critical inputs that we generate via `randomUUID()` (which
 * always emits v4) — narrowing the accepted shape removes the implicit
 * "any UUID matches" surface the more permissive `isValidUuid` would allow.
 */
export function isValidUuidV4(value: string): boolean {
  return UUID_V4_REGEX.test(value);
}
